import es from './es-api';
import cd from './cluster-data';

let data = {
  cluster : ()=>{
    cd.health = {};
    cd.cluster = {};
    es.get(es.ep.cluster.health, function(data){
      cd.health = $.extend({}, cd.health, data);
    });
    es.get(es.ep.cluster.state, function(data){
      cd.cluster.nodes = {};
      cd.cluster.indices = $.isPlainObject(data.metadata.indices) ? Object.keys(data.metadata.indices).sort((a,b)=>{
        if (data.metadata.indices[a].state  === "off"){
          return -1;
        }
        if(a > b){
          return -1;
        }
        if(a < b) {
          return 1;
        }
        return 0;
      }) : [];
      cd.cluster.indices.forEach((t,i)=>{
        cd.cluster.indices[i] = {name: t};
      });
      $.each(cd.cluster.indices, (i,v)=>{
        v.metadata = data.metadata.indices[v.name] || {};
      });
      if(data.routing_nodes['unassigned'] && data.routing_nodes['unassigned'].length){
        data.nodes.unassigned = {
          attributes : {},
          ephemeral_id: 'unassigned',
          master_node : false,
          name : 'Unassigned'
        };
        data.routing_nodes.nodes['unassigned'] = data.routing_nodes['unassigned'];
      }
      $.each(data.nodes, (i,v)=>{
        if(i === data.master_node) v.master_node = true;
        cd.cluster.nodes[i] = v;
        cd.cluster.nodes[i].node = {};
        $.each(data.routing_nodes.nodes[i], (i,v)=>{
          if(!v.node){
            v.node = 'unassigned';
          }
          if(!cd.cluster.nodes[v.node].node[v.index]){
            cd.cluster.nodes[v.node].node[v.index] = { shards : []};
          } 
          cd.cluster.nodes[v.node].node[v.index].shards.push(v);
          if(v.node === 'unassigned'){
            v.node = null;
          }
        });
        $.each(cd.cluster.nodes[i].node, (name, node)=>{
          let shard = node.shards;
          shard.sort((a,b)=>{
            return a.shard - b.shard;
          });
        });
      });
    });
    es.get(es.ep._stats, function(data){
      cd.health.shards = $.extend({}, data._shards);
      cd.cluster.indices.forEach((t,i)=>{
        cd.cluster.indices[i].info = $.extend({}, data.indices[t.name]);
      });
    });
  }
}

export default data;


// WEBPACK FOOTER //
// ./src/scripts/data/cluster-overview.js